import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsDataPropertyInterface } from '../../../stats/data/property.interface';
import { GtmStatsDataPropertyInterface } from '../data/property.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsAdapterList } from './list';
import { StatsEmitterEvent } from '../../../stats/emitter.event';
import { GtmStatsAdapterCategory } from './category';
import { GtmStatsAdapterListingStatus } from './listing-status';

export class GtmStatsAdapterProperty implements StatsAdapterInterface {
  /**
   *
   * @param rawData
   * @param context
   * @param eventName
   */
  constructor(
    protected rawData: StatsDataPropertyInterface,
    protected context: StatsContextInterface,
    protected eventName: StatsEmitterEvent
  ) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataPropertyInterface {
    const listAdapter = new GtmStatsAdapterList(this.context);

    const property: GtmStatsDataPropertyInterface = {
      id: (this.rawData.id || '').toString(),
      name: new GtmStatsAdapterCategory(this.rawData.offeringType).getData(),
      price: (this.rawData.leadValue || '').toString(),
      category: this.rawData.housingType || '',
      variant: this.rawData.verified,
      position: String(this.rawData.position || ''),
      quantity: 1,
      dimension4: (this.rawData.images || '').toString(),
      dimension5: (this.rawData.size || '').toString(),
      dimension6: new GtmStatsAdapterListingStatus(
        this.rawData.listingStatusDisplayed,
        this.rawData.isExclusive
      ).getData(),
      dimension7: this.rawData.housingType || '',
      dimension8: (this.rawData.agentUserId || '').toString(),
      dimension9: this.rawData.furnished || '',
      dimension10: this.rawData.rentalPeriodId || '',
      dimension11: this.rawData.bathrooms || '',
      dimension12: this.rawData.bedrooms || '',
      dimension13: ((this.rawData.agent && this.rawData.agent.id) || '').toString(),
      dimension14: ((this.rawData.broker && this.rawData.broker.id) || '').toString(),
      dimension15: ((this.rawData.locations && this.rawData.locations[0]) || '').toString(),
      dimension16: ((this.rawData.locations && this.rawData.locations[1]) || '').toString(),
      dimension17: ((this.rawData.locations && this.rawData.locations[2]) || '').toString(),
      dimension18: ((this.rawData.locations && this.rawData.locations[3]) || '').toString(),
      dimension19: ((this.rawData.locations && this.rawData.locations[4]) || '').toString(),
      dimension20: (this.rawData.qs || '').toString(),
      dimension21: (this.rawData.id || '').toString(),
      dimension24: (this.rawData.price || '').toString(),
      dimension29: (!!this.rawData.has360View).toString(),
      dimension53: (!!this.rawData.newProjects).toString(),
      promotion: false,
      list: listAdapter.getData(),
    };

    if (
      this.context.global.property_serp === true &&
      (this.rawData.isSmartAd || this.rawData.isCtsProperty || this.rawData.isAreaSpecialistProperty)
    ) {
      property.promotion = true;
    }

    // Property lead email
    if (this.context.local.lead && this.context.local.lead.medium === 'email') {
      property.metric6 = '6';

      // Property page
    } else if (this.context.global.property_page) {
      property.metric1 = '1';
    }

    // Property save/unsave
    if (this.eventName === StatsEmitterEvent.propertySave || this.eventName === StatsEmitterEvent.propertyUnsave) {
      property.metric9 = '1';

      // Property save/unsave CTA
      if (this.context.local.property_save_cta) {
        property.button = this.context.local.property_save_cta;
      }
    }

    // Property gallery browse
    if (this.eventName === StatsEmitterEvent.propertyImageBrowse) {
      property.metric2 = '1';
    }

    return property;
  }
}
